__turbopack_context__.v({
  "desktopPrimaryOffers": "buy-client-module__MUURVq__desktopPrimaryOffers",
  "mobilePrimaryOffers": "buy-client-module__MUURVq__mobilePrimaryOffers",
  "primaryOffersWrapper": "buy-client-module__MUURVq__primaryOffersWrapper",
});
